import {
  ClientPortfolioSortBy,
  ProjectSummariesResponseBody,
} from '@black-bear-energy/black-bear-energy-common'
import {
  UseQueryResult,
  keepPreviousData,
  useQuery,
} from '@tanstack/react-query'
import { AxiosInstance } from 'axios'
import { useApiWithIDTokenGranted } from 'state/modules/common'

export const useProjectSummaries = (
  search: string = '',
  sortBy: ClientPortfolioSortBy = ClientPortfolioSortBy.Name,
  sortAsc: boolean = true,
  page: number = 1
): UseQueryResult<ProjectSummariesResponseBody, Error> => {
  const api = useApiWithIDTokenGranted()

  return useQuery({
    queryKey: [api, 'projectSummaries', search, sortBy, sortAsc, page],
    queryFn: () =>
      fetchProjectSummaries(
        api as AxiosInstance,
        search,
        sortBy,
        sortAsc,
        page
      ),
    placeholderData: keepPreviousData,
    enabled: !!api,
  })
}

async function fetchProjectSummaries(
  api: AxiosInstance,
  search: string,
  sortBy: ClientPortfolioSortBy,
  sortAsc: boolean,
  page: number
): Promise<ProjectSummariesResponseBody> {
  const response = await api.get<ProjectSummariesResponseBody>(
    '/project-summaries',
    {
      params: {
        search,
        sortBy,
        sortAsc,
        page,
      },
    }
  )
  return response.data
}
